import React from 'react';
import { Badge } from './ui/badge';
import { useContent } from '../hooks/useContent';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (src) =>
  !src ? '' : src.startsWith('http') ? src : `${BACKEND_URL}${src}`;

const Partners = () => {
  const { data: partners } = useContent('partners', []);
  const list = Array.isArray(partners) ? partners : [];

  if (list.length === 0) return null;

  return (
    <section className="py-20 bg-white" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <Badge className="mb-4 bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/20">
            Our Partners
          </Badge>
          <h2 className="text-4xl md:text-5xl font-serif text-[#0A1628] mb-4">
            Supported by <span className="italic text-[#D4AF37]">Leaders</span>
          </h2>
          <p className="text-gray-600">
            We are proud to work alongside these organisations in our mission to empower communities.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-4 md:gap-6 items-center max-w-7xl mx-auto">
          {list.map((partner) => {
            const img = (
              <img
                src={resolveImg(partner.logo)}
                alt={partner.name}
                title={partner.name}
                className="max-w-full h-auto max-h-16 md:max-h-20 object-contain"
              />
            );
            return (
              <div
                key={partner.id || partner.name}
                className="flex items-center justify-center p-3 hover:scale-105 transition-transform"
                data-testid={`partner-${partner.id || partner.name}`}
              >
                {partner.link_url ? (
                  <a
                    href={partner.link_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center"
                  >
                    {img}
                  </a>
                ) : (
                  img
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Partners;
